import {createSlice} from "@reduxjs/toolkit";
import {setUIPipelineFlowTransportSearchFilter} from "./actions";
import {PipelineFlowTransportSearchCriteria} from "@ots-frontend/ots-data";

type PipelineFlowTransportUIState = {
  searchFilter?: PipelineFlowTransportSearchCriteria
}

const INITIAL_STATE: Readonly<PipelineFlowTransportUIState> = {};

const pipelineFlowTransportUISlice = createSlice({
  name: "ots-ui/pipeline-flow-transport",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIPipelineFlowTransportSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const pipelineFlowTransportUIReducer = pipelineFlowTransportUISlice.reducer;
